import { TFunction } from 'i18next';

export enum WfRecoveryStatus {
  Unaddressed = 'unaddressed',
  NoAccessPermitted = 'siteInaccessible',
  FloodingResponsePartReplacementRequired = 'FloodingResponsePartReplacementRequired',
  Restored = 'recoveryCompleted',
}

export const WfRecoveryStatusMapping = (t: TFunction) => ({
  [WfRecoveryStatus.Unaddressed]: {
    title: t('wf.statusInformationRegistration.recoveryOptions.unaddressed'),
    value: WfRecoveryStatus.Unaddressed,
  },
  [WfRecoveryStatus.NoAccessPermitted]: {
    title: t('wf.statusInformationRegistration.recoveryOptions.noAccessPermitted'),
    value: WfRecoveryStatus.NoAccessPermitted,
  },
  [WfRecoveryStatus.FloodingResponsePartReplacementRequired]: {
    title: t(
      'wf.statusInformationRegistration.recoveryOptions.floodingResponsePartReplacementRequired'
    ),
    value: WfRecoveryStatus.FloodingResponsePartReplacementRequired,
  },
  [WfRecoveryStatus.Restored]: {
    title: t('wf.statusInformationRegistration.recoveryOptions.restored'),
    value: WfRecoveryStatus.Restored,
  },
});

export const getRecoveryStatusOptions = (t: TFunction) => Object.values(WfRecoveryStatusMapping(t));

export function resolveResponseInputForApi(
  responseInput: string,
  floodRequired: boolean,
  partsRequired: boolean
): string {
  if (responseInput !== WfRecoveryStatus.FloodingResponsePartReplacementRequired) {
    return responseInput;
  }
  if (partsRequired) return 'partsReplace';
  if (floodRequired) return 'floodResponse';
  return 'needResponse';
}

export function resolveResponseInputFromApi(responseInput: string | undefined): WfRecoveryStatus {
  switch (responseInput) {
    case WfRecoveryStatus.Unaddressed:
    case WfRecoveryStatus.NoAccessPermitted:
    case WfRecoveryStatus.Restored:
      return responseInput;
    case 'partsReplace':
    case 'floodResponse':
    case 'needResponse':
      return WfRecoveryStatus.FloodingResponsePartReplacementRequired;
    default:
      return WfRecoveryStatus.Unaddressed;
  }
}
